export default "__VITE_ASSET__WA0dpNGV__"